module.exports = __webpack_public_path__ + "img/portraits_16_V.5b18d453.webp";